<template>
    <v-dialog v-model="dialogVisible" max-width="800" scrollable>
        <v-card class=" pa-6" elevation="2" :max-width="maxWidth">
            <v-card-text>
                <div class="markdown-body" v-html="markdown"></div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="cerrar">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        markdown: {
            type: String,
            required: true
        },
        maxWidth: {
            type: [String, Number],
            default: '900'
        },
        value: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        dialogVisible: false
    }),
    watch: {
        value(nuevo) {
            this.dialogVisible = nuevo
        },
        dialogVisible(nuevo) {
            this.$emit('input', nuevo)
        }
    },
    methods: {
        cerrar() {
            this.dialogVisible = false
        },
    }
}
</script>

<style scoped>
/* Estilos típicos para que se vea bien con Vuetify */
.markdown-body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.6;
    color: #333;
}

.markdown-body :deep(h1),
.markdown-body :deep(h2) {
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.3em;
}

.markdown-body :deep(pre) {
    background: #f6f8fa;
    padding: 16px;
    border-radius: 6px;
    overflow-x: auto;
}

.markdown-body :deep(code) {
    background: #f6f8fa;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-family: 'Consolas', 'Courier New', monospace;
}

.markdown-body :deep(ul),
.markdown-body :deep(ol) {
    padding-left: 2em;
}
</style>